jQuery( function ( $ ) {

	$( '#email-log, #password-log' ).on( 'input propertychange', function () {
		const email = $( '#email-log' ).val();
		const password = $( '#password-log' ).val();
		if ( email && password ) {
			$( '#login' ).prop( 'disabled', false );
		}
		else {
			$( '#login' ).prop( 'disabled', true );
		}
	} );


	$( 'form' ).submit( function () {
		$( this ).find( 'button[type=submit]' ).prop( 'disabled', true ).find( 'span' ).show();
	} );

	$( '.to-login, .to-new-customer' ).click( function ( event ) {
		event.preventDefault();
		if ( $( this ).hasClass( 'to-login' ) ) {
			$( '#pills-Login-tab' ).click();
		}
		else {
			$( '#pills-customer' ).click();
		}

		window.scroll( {
			top: 0,
			left: 0,
			behavior: 'smooth',
		} );
	} );


	// eslint-disable-next-line require-jsdoc
	function maybeEnableCreateAccuntSubmit () {
		const shouldBeEnabled = $( '#name' ).val() &&
		$( '#surname' ).val() &&
		$( '#passwordCreate' ).val() &&
		$( '#passwordConfirm' ).val() &&
		$( 'input[name=emailCreateNew]' ).val();
		if ( shouldBeEnabled ) {
			$( '#create' ).prop( 'disabled', false );
		}
		else {
			$( '#create' ).prop( 'disabled', true );
		}
	}

	$( '#name, #surname, #passwordCreate, #passwordConfirm' ).on( 'keyup', function () {
		maybeEnableCreateAccuntSubmit();
	} );

	// $( 'input[name=emailCreateNew]' ).on( 'keyup', _.debounce( async function ( event ) {
	// 	const $this = $( this );
	// 	const $formGroup = $this.closest( '.form-group' );
	// 	$formGroup.find( '.fa-info-circle' ).hide();
	// 	$formGroup.find( '.invalid-feedback' ).hide();
	// 	if ( !event.target.value ) {
	// 		return;
	// 	}
	// 	// eslint-disable-next-line no-useless-escape
	// 	const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	// 	if ( !regex.test( event.target.value ) ) {
	// 		return;
	// 	}

	// 	$this.prop( 'disabled', true );
	// 	$formGroup.find( '.checking-mail' ).show();

	// 	const formData = new FormData();
	// 	formData.append( 'action', 'check_email_exists' );
	// 	formData.append( 'email', event.target.value );
	// 	const response = await $.ajax( {
	// 		method: 'post',
	// 		processData: false,
	// 		contentType: false,
	// 		cache: false,
	// 		data: formData,
	// 		url: red61.ajax_url,
	// 	} ).promise();

// 	$( this ).data( 'mail-exists', response.exists );
// 	if ( true === response.exists ) {
// 		$formGroup.find( '.fa-info-circle' ).show();
// 		$formGroup.find( '.invalid-feedback' ).show();
// 	}
// 	$formGroup.find( '.checking-mail' ).hide();
// 	$this.removeProp( 'disabled' );
// 	maybeEnableCreateAccuntSubmit();
// }, 300 ) );
} );
